import { useEffect, useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import {
  Button,
  Form,
  Grid,
  Input,
  Row,
  SelectForm,
  Span,
  PhoneInput,
  InputMask
} from 'components'
import { useForm } from 'react-hook-form'
import { IFornecedor } from 'services/NGT/SupplierRegistration'
import { buscaCep } from 'services/Utils/buscaCep'
import { COLORS, FONTS, SPACING, TYPOGRAPHY } from 'utils'

import { SCHEMA } from '../../yup'
import { usePersistForm } from 'hooks'

interface FormProps {
  handleSubmitForm: any
  isModalOpen: boolean
  toggleModal: () => void
}

const ITS_NOT_LIRYCS_PATTERN = /[^a-zA-z\s]/g

export const SupplierRegistrationForm: React.FC<FormProps> = ({
  handleSubmitForm
}) => {
  const {
    clearErrors,
    control,
    watch,
    handleSubmit,
    reset,
    setValue,
    formState: { errors }
  } = useForm<IFornecedor>({
    defaultValues: {
      cdTipoFornecedor: 'J',
      contatosComercial: [{ cdTipo: 'Comercial', nmContato: '', txEmail: '' }],
      contatosImportacao: [
        { cdTipo: 'Importacao', nmContato: '', txEmail: '' }
      ],
      contatosSeguranca: [{ cdTipo: 'Seguranca', nmContato: '', txEmail: '' }],
      contatosTrabalhista: [
        { cdTipo: 'Trabalhista', nmContato: '', txEmail: '' }
      ]
    },
    resolver: yupResolver(SCHEMA.supplierForm)
  })

  usePersistForm('ngt_supplier_registration', {
    setValue,
    watch
  })

  const flSap = false
  const form = watch()
  const typeSupplier = watch('cdTipoFornecedor', 'J')
  const responsibleDoc = watch('cdCpfResponsavel')

  const [listComercial, setListComercial] = useState([
    {
      cdTipo: 'Comercial',
      id: 0,
      nmContato: '',
      txEmail: ''
    }
  ])

  const [listTrabalhista, setListTrabalhista] = useState([
    {
      cdTipo: 'Trabalhista',
      id: 0,
      nmContato: '',
      txEmail: ''
    }
  ])

  const [listSeguranca, setListSeguranca] = useState([
    {
      cdTipo: 'Seguranca',
      id: 0,
      nmContato: '',
      txEmail: ''
    }
  ])

  const [listImportacao, setListImportacao] = useState([
    {
      cdTipo: 'Importacao',
      id: 0,
      nmContato: '',
      txEmail: ''
    }
  ])

  const handleDelete = (id: number, actualValue, setFunction, fieldSet) => {
    const cpyArr = actualValue.slice()
    const deleteTargetId = cpyArr.filter((contatos) => contatos.id !== id)
    setFunction(deleteTargetId)
    setValue(fieldSet, deleteTargetId)
  }

  const handleNewItemComercial = (actualValue, setFunction, tipo) => {
    setFunction([
      ...actualValue,
      {
        cdTipo: tipo,
        id: actualValue[actualValue.length - 1].id + 1,
        nmContato: '',
        txEmail: ''
      }
    ])
  }

  const handleComercial = (
    value,
    index,
    campo,
    actualValue,
    setFunction,
    fieldSet
  ) => {
    const cpyArr = actualValue.slice()
    cpyArr[index][campo] = value
    setFunction(cpyArr)
    setValue(fieldSet, cpyArr)
  }

  const handleClearForm = () => {
    setListTrabalhista([
      {
        cdTipo: 'Trabalhista',
        id: 0,
        nmContato: '',
        txEmail: ''
      }
    ])

    setListComercial([
      {
        cdTipo: 'Comercial',
        id: 0,
        nmContato: '',
        txEmail: ''
      }
    ])

    setListImportacao([
      {
        cdTipo: 'Importacao',
        id: 0,
        nmContato: '',
        txEmail: ''
      }
    ])

    setListSeguranca([
      {
        cdTipo: 'Seguranca',
        id: 0,
        nmContato: '',
        txEmail: ''
      }
    ])

    reset({
      cdCep: '',
      cdCpfResponsavel: '',
      cdDocto: '',
      cdFornecedorSap: '',
      cdTipoFornecedor: 'J',
      contatosComercial: [{ cdTipo: 'Comercial', nmContato: '', txEmail: '' }],
      contatosImportacao: [
        { cdTipo: 'Importacao', nmContato: '', txEmail: '' }
      ],
      contatosSeguranca: [{ cdTipo: 'Seguranca', nmContato: '', txEmail: '' }],
      contatosTrabalhista: [
        { cdTipo: 'Trabalhista', nmContato: '', txEmail: '' }
      ],
      nmFornecedor: '',
      nmResponsavel: '',
      nuCelResponsavel: '',
      nuCelular: '',
      nuNumero: '',
      nuTelefone: '',
      sgEstado: '',
      sgPais: '',
      txBairro: '',
      txCidade: '',
      // txCno: "",
      txComplemento: '',
      txEmailResponsavel: '',
      txEndereco: ''
    })
  }

  // const handleResponseMar

  const [marginLeft, setMarginLeft] = useState(0)
  const [marginTop, setMarginTop] = useState(0);

  useEffect(() => {

    if (form.cdCep?.length === 8 && Number(form.cdCep)) {
      buscaCep(
        `${form.cdCep.substring(0, 5)}-${form.cdCep.substring(5, 8)}`
      ).then(({ data }) => {
        reset(
          {
            sgEstado: '',
            txBairro: '',
            txCidade: '',
            txEndereco: ''
          },
          {
            keepValues: true
          }
        )
        setValue('txEndereco', data?.logradouro)
        setValue('txBairro', data?.bairro)
        setValue('txCidade', data?.localidade)
        setValue('sgEstado', data?.uf)
      })
    }

    if (form.cdCep?.length === 9) {
      buscaCep(form.cdCep).then(({ data }) => {
        if (!data.erro) {
          setValue('txEndereco', data?.logradouro)
          setValue('txBairro', data?.bairro)
          setValue('txCidade', data?.localidade)
          setValue('sgEstado', data?.uf)
        }
      })
    }

    //Responsividade de Margin
    const handleZoomChange = () => {
      const scale = window.innerWidth

      if (scale <= 1360) {
        // 110% de zoom
        setMarginLeft(5)
      } else {
        // 100% de zoom
        setMarginLeft(20)
      }

      if (scale <= 1060) {
        // 125% de zoom
        setMarginTop(7)
      }
    }

    window.addEventListener('resize', handleZoomChange)
    handleZoomChange()

    return () => {
      window.removeEventListener('resize', handleZoomChange)
    }
  }, [form.cdCep])

  const isValidValue = (
    event: React.ChangeEvent<HTMLInputElement>
  ): boolean => {
    const onlyLetters = null
    const isValid = [onlyLetters].includes(
      event.target.value.match(ITS_NOT_LIRYCS_PATTERN)
    ) as boolean

    return isValid
  }

  useEffect(() => {
    setValue('cdDocto', '')
  }, [typeSupplier])

  return (
    <Form
      onSubmit={handleSubmit((data) => {
        handleSubmitForm(data)
        handleClearForm()
        reset()
      })}
      marginLeft={SPACING.spacing20}
      marginRight={SPACING.spacing20}
      marginBottom={SPACING.spacing100}
      padding={SPACING.spacing20}
      boxShadow={`0 0 1em ${COLORS.lightGray}`}
    >
      <Grid
        gridCols="0.6fr 0.8fr 1fr 1fr 3fr 0.8fr 1.2fr"
        gridGap={`0 ${SPACING.spacing15}`}
        margin={`0 0 ${SPACING.spacing30} 0`}
      >
        <Input
          control={control}
          errors={errors}
          label="Código SAP"
          placeholder="Gerado SAP"
          formValue="cdFornecedorSap"
          disabled
        />
        <Input label="Cód. Fornecedor" placeholder="Gerado Sistema" disabled />
        <SelectForm
          marginTop="-3px"
          control={control}
          errors={errors}
          formValue="cdTipoFornecedor"
          label="Tipo"
          defaultValue="J"
          listOptions={[
            { label: 'Pessoa Jurídica', value: 'J' },
            { label: 'Pessoa Física', value: 'F' },
            { label: 'Estrangeira', value: 'E' }
          ]}
          placeholder="Selecione"
        />
        {typeSupplier === 'J' ? (
          <Input
            control={control}
            errors={errors}
            label="CNPJ"
            placeholder="CNPJ"
            mask={['##.###.###/####-##']}
            formValue="cdDocto"
            maxLength={18}
          />
        ) : null}
        {typeSupplier === 'F' ? (
          <Input
            control={control}
            errors={errors}
            label="CPF"
            placeholder="CPF"
            mask={['###.###.###-##']}
            formValue="cdDocto"
            maxLength={14}
          />
        ) : null}
        <Input
          control={control}
          errors={errors}
          label="Fornecedor"
          placeholder="Nome do Fornecedor"
          formValue="nmFornecedor"
          maxLength={100}
          style={typeSupplier === 'E' ? { width: '360.14px' } : null}
        />
        <Input
          control={control}
          errors={errors}
          label="CEP"
          placeholder="00000-000"
          formValue="cdCep"
          mask={['#####-###']}
          maxLength={9}
          required
          style={typeSupplier === 'E' ? { width: '152.27px' } : null}
        />
        <Row
          alignItems="flex-start"
          justifyContent="flex-end"
          marginTop="-4px"
          style={
            typeSupplier === 'E'
              ? {
                width: '144px',
                marginLeft: `${marginLeft}px`,
                marginTop: `${marginTop}px`
              }
              : null
          }
        >
          {flSap ? (
            <CheckBoxIcon color="primary" />
          ) : (
            <CheckBoxOutlineBlankIcon color={'disabled'} />
          )}
          <Span text="Importado pelo SAP" marginTop="5px" />
        </Row>
      </Grid>

      <Grid
        gridCols="2.5fr 1fr 1fr 2fr 1.5fr 0.5fr"
        gridGap={`0 ${SPACING.spacing15}`}
        margin={`0 0 ${SPACING.spacing30} 0`}
      >
        <Input
          control={control}
          errors={errors}
          label="Endereço"
          placeholder="Preenchido automaticamente após o CEP"
          formValue="txEndereco"
          maxLength={50}
          required
        />
        <Input
          control={control}
          errors={errors}
          label="Nº do Logradouro"
          placeholder="Nº"
          formValue="nuNumero"
          maxLength={10}
          required
        />
        <Input
          control={control}
          errors={errors}
          label="Complemento"
          placeholder="Complemento"
          formValue="txComplemento"
          maxLength={50}
        />
        <Input
          control={control}
          errors={errors}
          label="Cidade"
          placeholder="Preenchido automaticamente após o CEP"
          formValue="txCidade"
          maxLength={50}
          required
        />
        <Input
          control={control}
          label="Estado"
          formValue="sgEstado"
          value={form.sgEstado}
          placeholder="Preenchido autom. após o CEP"
          errors={errors}
          maxLength={2}
          required
        />
      </Grid>

      <Grid
        gridCols="2.5fr 1fr 1fr 2fr 1.5fr 0.5fr"
        gridGap={`0 ${SPACING.spacing15}`}
        margin={`0 0 ${SPACING.spacing30} 0`}
      >
        <Input
          control={control}
          errors={errors}
          label="Bairro"
          placeholder="Preenchido automaticamente após o CEP"
          formValue="txBairro"
          maxLength={50}
          required
        />
        <PhoneInput
          control={control}
          errors={errors}
          label="Telefone"
          placeholder="+000 (00) 0000-0000"
          formValue="nuTelefone"
          required
        />
        <PhoneInput
          control={control}
          errors={errors}
          label="Celular"
          placeholder="+000 (00) 0000-0000"
          formValue="nuCelular"
          required
        />
        <Input
          control={control}
          errors={errors}
          label="País"
          placeholder="País"
          defaultValue="BR"
          formValue="sgPais"
          maxLength={2}
          required
        />
        {/* <Input
          control={control}
          errors={errors}
          label="CNO (Cadastro Nacional de Obras)"
          placeholder="CNO"
          formValue="txCno"
          maxLength={50}
          required
        /> */}
      </Grid>

      <Span
        text="RESPONSÁVEL PELA EMPRESA"
        color={COLORS.black}
        fontSize={TYPOGRAPHY.bodySize16}
        fontWeight={FONTS.bold}
      />
      <Grid
        gridCols="2.5fr 1fr 3fr 1.5fr 0.5fr"
        gridGap={`0 ${SPACING.spacing15}`}
        margin={`0 0 ${SPACING.spacing30} 0`}
      >
        <InputMask
          control={control}
          errors={errors}
          type="letter"
          label="Nome"
          placeholder="Nome Completo"
          formValue="nmResponsavel"
          maxLength={50}
          required
        />
        <Input
          control={control}
          errors={errors}
          label="CPF / Passaporte"
          placeholder="Nº"
          formValue="cdCpfResponsavel"
          mask={
            isNaN(parseInt(responsibleDoc))
              ? ['NN##########']
              : ['###.###.###-##']
          }
          maxLength={14}
        />
        <Input
          control={control}
          errors={errors}
          label="E-mail"
          placeholder="Endereço de E-mail"
          formValue="txEmailResponsavel"
          maxLength={50}
          required
        />
        <PhoneInput
          control={control}
          errors={errors}
          label="Contato"
          placeholder="(00) 00000-0000"
          formValue="nuCelResponsavel"
          required
        />
      </Grid>

      <Span
        text="COMERCIAL"
        color={COLORS.black}
        fontSize={TYPOGRAPHY.bodySize16}
        fontWeight={FONTS.bold}
      />
      <>
        {listComercial.map((data, index) => (
          <Grid
            key={data.id}
            gridCols="2.5fr 3fr 0.2fr 0.2fr 2.3fr"
            gridGap={`0 ${SPACING.spacing15}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <Input
              value={data.nmContato}
              onChange={(e) => {
                if (isValidValue(e)) {
                  handleComercial(
                    e.target.value,
                    index,
                    'nmContato',
                    listComercial,
                    setListComercial,
                    'contatosComercial'
                  )
                  clearErrors('contatosComercial')
                }
              }}
              label="Contato"
              placeholder="Contato"
              customError={
                errors &&
                  errors['contatosComercial'] &&
                  errors['contatosComercial'][index]
                  ? errors['contatosComercial'][index]?.nmContato
                  : null
              }
              maxLength={50}
              required
            />
            <Input
              value={data.txEmail}
              onChange={(e) => {
                handleComercial(
                  e.target.value,
                  index,
                  'txEmail',
                  listComercial,
                  setListComercial,
                  'contatosComercial'
                )
                clearErrors('contatosComercial')
              }}
              label="E-mail"
              placeholder="Endereço de E-mail"
              customError={
                errors &&
                  errors['contatosComercial'] &&
                  errors['contatosComercial'][index]
                  ? errors['contatosComercial'][index]?.txEmail
                  : null
              }
              maxLength={50}
              required
            />
            <Button
              text="+"
              onClick={() =>
                handleNewItemComercial(
                  listComercial,
                  setListComercial,
                  'Comercial'
                )
              }
            />
            {listComercial.length > 1 && (
              <Button
                text="-"
                onClick={() =>
                  handleDelete(
                    data.id,
                    listComercial,
                    setListComercial,
                    'contatosComercial'
                  )
                }
              />
            )}
          </Grid>
        ))}
      </>
      <Span
        text="TRABALHISTA"
        color={COLORS.black}
        fontSize={TYPOGRAPHY.bodySize16}
        fontWeight={FONTS.bold}
      />
      <>
        {listTrabalhista.map((data, index) => (
          <Grid
            key={data.id}
            gridCols="2.5fr 3fr 0.2fr 0.2fr 2.3fr"
            gridGap={`0 ${SPACING.spacing15}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <Input
              onChange={(e) => {
                if (isValidValue(e)) {
                  handleComercial(
                    e.target.value,
                    index,
                    'nmContato',
                    listTrabalhista,
                    setListTrabalhista,
                    'contatosTrabalhista'
                  )
                  clearErrors('contatosTrabalhista')
                }
              }}
              label="Contato"
              customError={
                errors &&
                  errors['contatosTrabalhista'] &&
                  errors['contatosTrabalhista'][index]
                  ? errors['contatosTrabalhista'][index]?.nmContato
                  : null
              }
              placeholder="Contato"
              value={data.nmContato}
              maxLength={50}
              required
            />
            <Input
              onChange={(e) => {
                handleComercial(
                  e.target.value,
                  index,
                  'txEmail',
                  listTrabalhista,
                  setListTrabalhista,
                  'contatosTrabalhista'
                )
                clearErrors('contatosTrabalhista')
              }}
              label="E-mail"
              placeholder="Endereço de E-mail"
              value={data.txEmail}
              customError={
                errors &&
                  errors['contatosTrabalhista'] &&
                  errors['contatosTrabalhista'][index]
                  ? errors['contatosTrabalhista'][index]?.txEmail
                  : null
              }
              maxLength={50}
              required
            />
            <Button
              text="+"
              onClick={() =>
                handleNewItemComercial(
                  listTrabalhista,
                  setListTrabalhista,
                  'Trabalhista'
                )
              }
            />
            {listTrabalhista.length > 1 && (
              <Button
                text="-"
                onClick={() =>
                  handleDelete(
                    data.id,
                    listTrabalhista,
                    setListTrabalhista,
                    'contatosTrabalhista'
                  )
                }
              />
            )}
          </Grid>
        ))}
      </>
      <Span
        text="SEGURANÇA"
        color={COLORS.black}
        fontSize={TYPOGRAPHY.bodySize16}
        fontWeight={FONTS.bold}
      />
      <>
        {listSeguranca.map((data, index) => (
          <Grid
            key={data.id}
            gridCols="2.5fr 3fr 0.2fr 0.2fr 2.3fr"
            gridGap={`0 ${SPACING.spacing15}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <Input
              onChange={(e) => {
                if (isValidValue(e)) {
                  handleComercial(
                    e.target.value,
                    index,
                    'nmContato',
                    listSeguranca,
                    setListSeguranca,
                    'contatosSeguranca'
                  )
                  clearErrors('contatosSeguranca')
                }
              }}
              value={data.nmContato}
              label="Contato"
              placeholder="Contato"
              customError={
                errors &&
                  errors['contatosSeguranca'] &&
                  errors['contatosSeguranca'][index]
                  ? errors['contatosSeguranca'][index]?.nmContato
                  : null
              }
              maxLength={50}
              required
            />
            <Input
              onChange={(e) => {
                handleComercial(
                  e.target.value,
                  index,
                  'txEmail',
                  listSeguranca,
                  setListSeguranca,
                  'contatosSeguranca'
                )
                clearErrors('contatosSeguranca')
              }}
              label="E-mail"
              customError={
                errors &&
                  errors['contatosSeguranca'] &&
                  errors['contatosSeguranca'][index]
                  ? errors['contatosSeguranca'][index]?.txEmail
                  : null
              }
              placeholder="Endereço de E-mail"
              value={data.txEmail}
              maxLength={50}
              required
            />
            <Button
              text="+"
              onClick={() =>
                handleNewItemComercial(
                  listSeguranca,
                  setListSeguranca,
                  'Seguranca'
                )
              }
            />
            {listSeguranca.length > 1 && (
              <Button
                text="-"
                onClick={() =>
                  handleDelete(
                    data.id,
                    listSeguranca,
                    setListSeguranca,
                    'contatosSeguranca'
                  )
                }
              />
            )}
          </Grid>
        ))}
      </>
      <Span
        text="IMPORTAÇÃO"
        color={COLORS.black}
        fontSize={TYPOGRAPHY.bodySize16}
        fontWeight={FONTS.bold}
      />
      <>
        {listImportacao.map((data, index) => (
          <Grid
            key={data.id}
            gridCols="2.5fr 3fr 0.2fr 0.2fr 2.3fr"
            gridGap={`0 ${SPACING.spacing15}`}
            margin={`0 0 ${SPACING.spacing30} 0`}
          >
            <Input
              onChange={(e) => {
                if (isValidValue(e)) {
                  handleComercial(
                    e.target.value,
                    index,
                    'nmContato',
                    listImportacao,
                    setListImportacao,
                    'contatosImportacao'
                  )
                  clearErrors('contatosImportacao')
                }
              }}
              label="Contato"
              customError={
                errors &&
                  errors['contatosImportacao'] &&
                  errors['contatosImportacao'][index]
                  ? errors['contatosImportacao'][index]?.nmContato
                  : null
              }
              placeholder="Contato"
              value={data.nmContato}
              maxLength={50}
              required
            />
            <Input
              onChange={(e) => {
                handleComercial(
                  e.target.value,
                  index,
                  'txEmail',
                  listImportacao,
                  setListImportacao,
                  'contatosImportacao'
                )
                clearErrors('contatosImportacao')
              }}
              label="E-mail"
              customError={
                errors &&
                  errors['contatosImportacao'] &&
                  errors['contatosImportacao'][index]
                  ? errors['contatosImportacao'][index]?.txEmail
                  : null
              }
              placeholder="Endereço de E-mail"
              value={data.txEmail}
              maxLength={50}
              required
            />
            <Button
              text="+"
              onClick={() =>
                handleNewItemComercial(
                  listImportacao,
                  setListImportacao,
                  'Importacao'
                )
              }
            />
            {listImportacao.length > 1 && (
              <Button
                text="-"
                onClick={() =>
                  handleDelete(
                    data.id,
                    listImportacao,
                    setListImportacao,
                    'contatosImportacao'
                  )
                }
              />
            )}
          </Grid>
        ))}
      </>

      <Row justifyContent="flex-end">
        <Button text="Limpar" variantButton="text" onClick={handleClearForm} />
        <Button text="Salvar" type="submit" marginLeft={SPACING.spacing20} />
      </Row>
    </Form >
  )
}
